import { sumAppliedCreditNoteAmounts } from '@sequencehq/invoice-content'

import { AppliedCreditNote } from 'Invoices/types'

/**
 * Total value applied to an invoice across all applied credit notes, as
 * a major-unit decimal string. The single source of truth for how applied
 * credit notes are summed (used by both the credit note and payment drawers),
 * on Big.js to avoid floating-point drift.
 */
export const sumAppliedCreditNotes = (
  appliedCreditNotes: AppliedCreditNote[] = []
): string => sumAppliedCreditNoteAmounts(appliedCreditNotes)
